export default __webpack_public_path__ + "static/media/harryBates.e1240ad6.jpg";